const NEXT_PUBLIC_ADMIN_PANEL_API_BASE_URL =
  process.env.NEXT_PUBLIC_ADMIN_PANEL_API_BASE_URL;
const NEXT_PUBLIC_ADMIN_PANEL_API_TOKEN =
  process.env.NEXT_PUBLIC_ADMIN_PANEL_API_TOKEN;

class ApiClient {
  constructor() {
    this.baseURL = NEXT_PUBLIC_ADMIN_PANEL_API_BASE_URL;
    this.token = null;
  }

  setToken(token) {
    this.token = token;
    if (typeof window !== 'undefined') {
      localStorage.setItem('auth_token', token);
    }
  }

  getToken() {
    if (this.token) return '';
    if (typeof window !== 'undefined') {
      return localStorage.getItem('auth_token');
    }
    return null;
  }

  removeToken() {
    this.token = null;
    if (typeof window !== 'undefined') {
      localStorage.removeItem('auth_token');
    }
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;

    // const token =
    //   typeof window === 'undefined'
    //     ? 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFkbWluQHgtc3BhY2UuYWUiLCJpYXQiOjE3NTA3NTk4MDF9.IY80bQkbBvI8Dd6NGa2jk8BDsTMcX1QCvWPxzosrcC0'
    //     : this.getToken();

    const token = NEXT_PUBLIC_ADMIN_PANEL_API_TOKEN;

    const useFormData = options.useFormData === true;
    const skipAuth = options.skipAuth === true; // ✅

    delete options.useFormData; // remove custom flag before fetch
    delete options.skipAuth; // ✅ Remove custom flag

    const config = {
      method: options.method || 'GET',
      headers: {
        ...(skipAuth ? {} : token ? { Authorization: `Bearer ${token}` } : {}),
        ...(useFormData ? {} : { 'Content-Type': 'application/json' }),
        ...options.headers,
      },
      body: options.body,
    };

    // Automatically stringify JSON if needed
    if (
      !useFormData &&
      config.body &&
      typeof config.body === 'object' &&
      !(config.body instanceof FormData)
    ) {
      config.body = JSON.stringify(config.body);
    }

    try {
      const response = await fetch(url, config);

      if (!response.ok) {
        const result = await response.json().catch(() => ({
          success: false,
          message: 'Invalid JSON response from server',
        }));

        const error = new Error(result?.message || 'HTTP error');
        error.response = result;
        throw error;
      }

      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  async get(endpoint, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = queryString ? `${endpoint}?${queryString}` : endpoint;
    return this.request(url, { method: 'GET' });
  }
}

export const apiClient = new ApiClient();
